import { useQuery } from "@tanstack/react-query";
import { fetchLoginSuccess } from "../../services/apiAuth";
import { useDispatch } from "react-redux";
import { loginUser } from "../../reducers/auth.slice";
import { useError } from "../../context/ErrorContext";

type User = {
  clientName: string;
  clientPermissions: string[];
  isLoginUsingClientUrl: boolean;
  isProfileImageAvailable: boolean;
  isSuperAdminUser: boolean;
  loginURL: string;
  logoutURL: string;
  needToDisplayClientSwitchButton: boolean;
  permissions: string[];
  roleName: string;
  sessionTimeoutSeconds: number;
  subClientPermissions: string[];
  userFullName: string;
  userName: string;
  role: string;
}

export function useFetchLoginSuccess({ isAuthenticated }: { isAuthenticated: boolean }) {
  const { handleErrorAction } = useError();
  const dispatch = useDispatch();
  const { isFetching, data } = useQuery({
    queryKey: ['loginSuccessResponse'],
    queryFn: async () => {
      const { data } = await fetchLoginSuccess();
      let role = ""
      if (!!data?.isSuperAdminUser) {
        role = 'admin';
      } else {
        if (!!data?.isLoginUsingClientUrl) {
          role = 'client';
        } else {
          role = 'subClient';
        }
      }
      return { ...data, role } as User
    },
    enabled: !!isAuthenticated,
    staleTime: 0,
    cacheTime: 0,
    onSuccess: (data) => {
      dispatch(loginUser({ ...data }))
    },
    onError: (error: Error) => {
      handleErrorAction(error)
    }
  });

  return { isLoading: isFetching, data };
}